import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      textDecoration: 'none',
      color: palette.common.black
    },
    link: {
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        bottom: '-2px',
        right: '0',
        width: '0',
        height: '1.5px',
        backgroundColor: palette.divider,
        transition: 'width 0.6s ease'
      },
      '&:hover::before': {
        left: '0',
        right: 'auto',
        width: '100%'
      }
    },
    ressource: ({ color = 'gray' }: { color: string }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px',
      color: palette.text.white,
      fontWeight: 600,
      boxShadow: palette.shadows.boxInnerShadow,
      borderRadius: palette.borderRadius.default,
      transition: 'all 0.5s ease-out',
      '&:hover': {
        boxShadow: palette.shadows.boxInnerShadowHover
      },
      backgroundColor: color
    }),
    helpLanding: {
      fontWeight: 600,
      backgroundColor: palette.background.box,
      borderRadius: palette.borderRadius.default,
      padding: '5px',
      fontSize: '0.625rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
